import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchTeam } from '../services';

// Thunk asíncrono para obtener los datos de team desde la API
export const fetchTeamData = createAsyncThunk(
    'team/fetchTeamData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchTeam(); // Llama al servicio de la API
            return data;
        } catch (error) {
            return rejectWithValue(error.message); // Manejo de errores
        }
    }
);

const teamSlice = createSlice({
    name: 'team',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
        // Puedes agregar más acciones sincronas si es necesario
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTeamData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTeamData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchTeamData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default teamSlice.reducer;
